// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoadingSpinner_spinnerContainer__4xTzY","loadingSpinner":"LoadingSpinner_loadingSpinner__ZHL9k","spinner":"LoadingSpinner_spinner__RuUmt"};